import React, { useState, useEffect, useRef } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, EffectFade } from "swiper/modules";
import "swiper/css";
import "swiper/css/effect-fade";
import "./julWorks.css";

const shuffleArray = (array) => {
  return array.sort(() => Math.random() - 0.5);
};

const JulWorks = () => {
  const [slides, setSlides] = useState([]);
  const swiperRef = useRef(null);

  useEffect(() => {
    const imagePaths = Array.from({ length: 21 }, (_, i) => {
      const num = i + 1;
      return `/images/AboutPhotos/resim${String(num).padStart(3, "0")}.jpg`;
    });

    const alwaysFirst = "/images/AboutPhotos/resim012.jpg";
    const otherImages = imagePaths.filter((img) => img !== alwaysFirst);
    const shuffled = shuffleArray(otherImages);

    setSlides([alwaysFirst, ...shuffled]);
  }, []);

  const handleSlideChange = (swiper) => {
    swiper.params.autoplay.delay = 3000;
    swiper.autoplay.start();
  };

  return (
    <div className="julworks-page">
      <Swiper
        modules={[Autoplay, EffectFade]}
        slidesPerView={1}
        effect="fade"
        fadeEffect={{ crossFade: true }}
        autoplay={{ delay: 3000, disableOnInteraction: false }}
        loop={true}
        speed={1500}
        onSwiper={(swiper) => (swiperRef.current = swiper)}
        onSlideChange={handleSlideChange}
        className="julworks-slider"
      >
        {slides.map((item, index) => (
          <SwiperSlide key={index} className="slide-container">
            <img
              src={item}
              alt={`Slide ${index + 1}`}
              className="julworks-slide-image"
            />
            <img src="/images/logo.png" alt="Logo" className="logo-overlay" />
          </SwiperSlide>
        ))}
      </Swiper>
    </div>
  );
};

export default JulWorks;
